var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"linha-resumo-alertas"}},[_c('h3',[_c('i',{staticClass:"el-icon-s-flag",style:(`color: ${_vm.corIcone};`)}),_vm._v(_vm._s(_vm.textoDias))]),_c('h3',[_vm._v(_vm._s(_vm.totalAcumulado))])])
}
var staticRenderFns = []

export { render, staticRenderFns }